export default {
    state: {
        productModal: {
            isVisible: false,
            product: {}
        },
        groupsMenu: {
            isVisible: false,
            fatherName: '',
            groups: []
        }
    },
    mutations: {
        showProductModal (state, product) {
            state.productModal.product = product
            state.productModal.isVisible = true
        },
        closeProductModal (state) {
            state.productModal.isVisible = false
        },
        showGroupsMenu (state, group) {
            state.groupsMenu.fatherName = group.NMGRUPO
            state.groupsMenu.groups = Object.values(group.GRUPOS)
            state.groupsMenu.groups.forEach((group) => {
                group.isVisible = true
                group.showProducts = false
            })

            state.groupsMenu.isVisible = true
        },
        closeGroupsMenu (state) {
            state.groupsMenu.isVisible = false
        }
    },
    actions: {
        showProductModal ({ commit }, product) {
            commit('showProductModal', product)
        },
        closeProductModal ({ commit }) {
            commit('closeProductModal')
        },
        showGroupsMenu ({ commit }, group) {
            commit('showGroupsMenu', group)
        },
        closeGroupsMenu ({ commit }) {
            commit('closeGroupsMenu')
        }
    },
    getters: {
        productModal: (state) => state.productModal,
        groupsMenu: (state) => state.groupsMenu
    }
}
